import { render, staticRenderFns } from "./TruckCards.vue?vue&type=template&id=290017be&scoped=true"
import script from "./TruckCards.vue?vue&type=script&lang=js"
export * from "./TruckCards.vue?vue&type=script&lang=js"
import style0 from "./TruckCards.vue?vue&type=style&index=0&id=290017be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290017be",
  null
  
)

export default component.exports